export function stripHtml(str: string): string {
  if (str.includes('<a') || str.includes('<img')) {
    return str;
  }
  // To keep line breaks, we replace it with ___br___
  const replacedStr = str.replace(/<br\s*\/?>/gi, '___br___');
  const tmp = document.createElement('DIV');
  tmp.innerHTML = replacedStr;
  const txtContent = tmp.textContent || tmp.innerText || '';
  // Put the line breaks back
  return txtContent.replace(/___br___/g, '<br />');
}
